<template>
  <div class="bb-notifications-hr">
    <template
      v-for="(item, index) in notificationList"
      @click="goToRoute(item)"
    >
      <NotificationsWindowHr
        v-if="item.eventNotification === USER_NOTIFICATION_HR"
        :key="index"
        :item="item"
        :index="index"
        @onDelete="onDelete"
      />
      <NotificationsWindowReminder
        v-else-if="item.eventNotification === USER_NOTIFICATION_REMINDER"
        :item="item"
        :key="index"
        :index="index"
        @onDelete="onDelete"
      />
      <NotificationsWindowClientList
        v-else-if="item.eventNotification === CLIENT_NOTIFICATION_SYSTEM"
        :item="item"
        :key="index"
        :index="index"
        @onDelete="onDelete"
      />
      <NotificationsWindowMailing
        v-else-if="item.eventNotification === MAILING_NOTIFICATION"
        :item="item"
        :key="index"
        :index="index"
        @onDelete="onDelete"
      />
      <NotificationsWindowListOfProject
        v-else-if="item.eventNotification === LIST_OF_PROJECT_NOTIFICATION"
        :item="item"
        :key="index"
        :index="index"
        @onDelete="onDelete"
      />
      <NotificationsWindowAcademy
        v-else-if="item.eventNotification === LIST_OF_ACADEMY_NOTIFICATION"
        :item="item"
        :key="index"
        :index="index"
        @onDelete="onDelete"
      />
      <NotificationsWindowProject
        v-else
        :key="index"
        :item="item"
        :index="index"
        @onDelete="onDelete"
      />
    </template>
  </div>
</template>

<script>

import { NOTIFICATION_ALL_HR } from '@/constants/notificationHr'
import { EVENT_CATEGORY } from '@/constants/eventCategory'
import { USER_NOTIFICATION } from '@/constants/userNotification'
import NotificationsWindowMailing from '@/components/Notifications/NotificationsWindow/NotificationsWindowMailing'
import NotificationsWindowHr from '@/components/Notifications/NotificationsWindow/NotificationsWindowHr'
import NotificationsWindowReminder from '@/components/Notifications/NotificationsWindow/NotificationsWindowReminder'
import NotificationsWindowProject from '@/components/Notifications/NotificationsWindow/NotificationsWindowProject'
import NotificationsWindowClientList from '@/components/Notifications/NotificationsWindow/NotificationsWindowClientList'
// eslint-disable-next-line max-len
import NotificationsWindowListOfProject from '@/components/Notifications/NotificationsWindow/NotificationsWindowListOfProject'
import NotificationsWindowAcademy from '@/components/Notifications/NotificationsWindow/NotificationsWindowAcademy'

export default {
  name: 'NotificationsWindow',
  components: {
    NotificationsWindowHr,
    NotificationsWindowProject,
    NotificationsWindowReminder,
    NotificationsWindowClientList,
    NotificationsWindowMailing,
    NotificationsWindowListOfProject,
    NotificationsWindowAcademy
  },
  data: () => ({
    notification: {},
    notificationList: [],
    USER_NOTIFICATION_HR: USER_NOTIFICATION.USER_NOTIFICATION_HR,
    USER_NOTIFICATION_REMINDER: USER_NOTIFICATION.USER_NOTIFICATION_REMINDER,
    CLIENT_NOTIFICATION_SYSTEM: USER_NOTIFICATION.CLIENT_NOTIFICATION_SYSTEM,
    MAILING_NOTIFICATION: USER_NOTIFICATION.MAILING_NOTIFICATION,
    LIST_OF_PROJECT_NOTIFICATION: USER_NOTIFICATION.LIST_OF_PROJECT_NOTIFICATION,
    LIST_OF_ACADEMY_NOTIFICATION: USER_NOTIFICATION.LIST_OF_ACADEMY_NOTIFICATION
  }),
  sockets: {
    usersnotification (notification) {
      const { eventNotification } = notification
      if (eventNotification === this.USER_NOTIFICATION_HR) {
        this.hrNotifications(notification)
      } else {
        this.notifications(notification)
      }
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    notificationsListSideBar: {
      get () {
        return this.$store.getters.notificationsList
      },
      set (data) {
        this.$store.dispatch('setNotificationsList', data)
      }
    }
  },
  methods: {
    notifications (notification) {
      const { id } = this.userInfo
      const { user } = notification
      if (user !== id) return
      this.notificationList.unshift(notification)
      this.notificationsListSideBar.unshift(notification)
      setTimeout(() => {
        this.notificationList.pop()
      }, 7000)
    },
    hrNotifications (notification) {
      const { id } = this.userInfo
      const { notificationStatus, eventType, user } = notification
      if (user !== id) return
      const newNotificationStatus = NOTIFICATION_ALL_HR.find(({id}) => id === notificationStatus)
      const newItem = {
        ...notification,
        notificationStatus: newNotificationStatus,
        eventType: EVENT_CATEGORY.find(({id}) => id === eventType)
      }
      this.notificationList.unshift(newItem)
      this.notificationsListSideBar.unshift(newItem)
      setTimeout(() => {
        this.notificationList.pop()
      }, 7000)
    },
    onDelete (index) {
      this.notificationList.splice(index, 1)
    },
    goToRoute ({targetUser, notificationStatus}) {
      const { router } = notificationStatus
      if (!router) return
      const { name, nameRouteChildren } = router
      const [id] = targetUser
      this.$router.replace({
        name,
        params: { id, tab: 'time-off-balance', nameRouteChildren }
      }).catch(err => err)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-notifications-hr {
    @include global-font();
    display: grid;
    grid-gap: 8px 0;
    position: fixed;
    top: 28px;
    right: 50px;
    z-index: 9999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/Notifications/NotificationsWindow/NotificationsWindow.vue